namespace e5 {
    export interface ScriptLoaderOptions extends AbstractLoaderOptions {
        async?: boolean;
    }

    export class ScriptLoader extends AbstractLoader<HTMLScriptElement, ScriptLoaderOptions>{
        private _script: HTMLScriptElement;

        constructor(url: string, options: ScriptLoaderOptions = null) {
            super(url, options);

            var script = document.createElement("script");
            script.type = "text/javascript";
            script.async = this._options.async;

            script.onerror = (e) => {
                this.reject(e)
            }

            script.onload = async (e) => {
                this.resolve(script);
            }

            script.onprogress = (e: ProgressEvent) => {
                this._onProgress.dispatch(e.loaded, e.total, e);
            }

            script.src = url;
            document.head.appendChild(script);

            this._script = script;
        }

        public cancel(reason: any = null): this {
            this._script.onerror = null;
            this._script.src = "";
            this._script.removeAttribute("src");
            super.cancel(reason);
            return this;
        }

        protected finish(): void {
            var script = this._script;
            script.onerror = null;
            script.onload = null;
            script.onprogress = null;
            this._script = null;

            super.finish();
        }

        protected defaultOptions(): ScriptLoaderOptions {
            return {
                async: true
            };
        }
    }

    export interface LoaderOptionsMap {
        "script": ScriptLoaderOptions;
    }

    export interface LoaderMap {
        "script": ScriptLoader;
    }

    registerLoader("script", ScriptLoader);
}